import * as React from 'react';
import { AsideBuilderContacts } from '../AsideBuilderContacts';
import { AsideCianContacts } from '../AsideCianContacts';
import { PageRowLayout } from '../PageRowLayout';
import { PriceContainer } from '../../containers/Price';
import { BuilderContainer } from '../../containers/Builder';
import { StickyBlock } from '../StickyBlock';
import { LeadFactoryCallButtonContainer } from '../../containers/LeadFactoryCallButton';
import { MessageButtonContainer } from '../../containers/MessageButton';
import { RightPromoContainer } from '../../containers/RightPromoContainer';
import { RightReliableLabelContainer } from '../../containers/RightReliableLabel';
import { SelectionsButtonContainer } from '../../containers/SelectionsButtonContainer';
import { WorkTimeInfoContainer } from '../../containers/WorkTimeInfo';
import { NewbuildingPurchaseGiftSidebarTongueContainer } from '../../containers/NewbuildingPurchaseGiftPromo';
import { UpcomingSaleRequestFormContainer } from '../../containers/UpcomingSaleRequestFormContainer';
import { PageRowItem } from '../PageRowItem';
import { CallToActionContainer } from '../../containers/CallToAction';
import { COMPARISON_ENTRYPOINTS_ENABLED_CONFIG } from '../../containers/Comparison/constants';
import { useApplicationContext } from '../../utils/applicationContext';
import * as styles from './RightColumn.css';

const STICKY_BLOCK_TOP = 102;

export interface IRightColumnProps {
  dynamicCalltrackingPlaceType: string;
  isLeadFactory?: boolean;
  isUpcomingSale?: boolean;
}

export const RightColumn: React.FunctionComponent<IRightColumnProps> = ({
  dynamicCalltrackingPlaceType,
  isLeadFactory,
  isUpcomingSale,
}) => {
  const { config } = useApplicationContext();
  const [isPhoneShown, setIsPhoneShown] = React.useState(false);

  const handlePhoneShow = React.useCallback(() => setIsPhoneShown(true), []);

  const isComparisonEntrypointsEnabled = config.get<boolean>(COMPARISON_ENTRYPOINTS_ENABLED_CONFIG) || false;
  const ctaButtonSize = isComparisonEntrypointsEnabled ? ('L' as const) : undefined;

  /* istanbul ignore next */
  if (isUpcomingSale) {
    return (
      <StickyBlock top={STICKY_BLOCK_TOP}>
        <PageRowLayout fullwidth>
          <PageRowItem>
            <UpcomingSaleRequestFormContainer />
          </PageRowItem>
        </PageRowLayout>
      </StickyBlock>
    );
  }

  if (isLeadFactory) {
    return (
      <StickyBlock top={STICKY_BLOCK_TOP}>
        <PageRowLayout fullwidth>
          <PageRowItem>
            <PriceContainer />
            <BuilderContainer />
            <AsideCianContacts>
              <LeadFactoryCallButtonContainer placeType={dynamicCalltrackingPlaceType} size="M" />
              <SelectionsButtonContainer analyticsType="sidebar" fullWidth secondary XXL />
              <WorkTimeInfoContainer />
            </AsideCianContacts>
            <RightReliableLabelContainer />
          </PageRowItem>
        </PageRowLayout>
      </StickyBlock>
    );
  }

  return (
    <StickyBlock top={STICKY_BLOCK_TOP}>
      <PageRowLayout fullwidth>
        {/* Свой контекст наложения: язычок акции с z-index -1 уходит под карточку, а не под секцию PageRowLayout */}
        <div className={styles['contacts-card']}>
          <PageRowItem>
            <RightPromoContainer />
            <PriceContainer />
            <BuilderContainer />
            <AsideBuilderContacts
              actionButton={
                <CallToActionContainer
                  dynamicCalltrackingPlaceType={dynamicCalltrackingPlaceType}
                  analyticOnOpenActionName="Open_jk_card_blockJK"
                  fullWidth
                  XXL
                  size={ctaButtonSize}
                  onPhoneShow={handlePhoneShow}
                />
              }
              messageButton={
                <MessageButtonContainer
                  asIcon={!isPhoneShown}
                  buttonSize={ctaButtonSize}
                  placeType="Open_jk_card_blockJK"
                />
              }
              workTimeInfo={<WorkTimeInfoContainer />}
            />
            <RightReliableLabelContainer />
          </PageRowItem>
          <NewbuildingPurchaseGiftSidebarTongueContainer />
        </div>
      </PageRowLayout>
    </StickyBlock>
  );
};
